import { useState, useEffect } from 'react';

const LOGO_URL = 'https://static.readdy.ai/image/0227718025500d4b5e94dda25ab00f4a/d587ea3beae87ba159093a83d7a76a28.jpeg';

const navLinks = [
  { label: '홈', href: '#home' },
  { label: '합격자 명단', href: '#admissions' },
  { label: '소개', href: '#about' },
  { label: '프로그램', href: '#programs' },
  { label: '강사진', href: '#instructors' },
  { label: '스페셜', href: '#schedule' },
  { label: '연락처', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      const sections = navLinks.map((l) => l.href.replace('#', ''));
      let current = 'home';
      sections.forEach((id) => {
        const el = document.getElementById(id);
        if (el && window.scrollY >= el.offsetTop - 100) {
          current = id;
        }
      });
      setActiveSection(current);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/95 backdrop-blur-sm border-b border-stone-200' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <a href="#home" onClick={(e) => handleNavClick(e, '#home')} className="flex items-center gap-3 cursor-pointer">
          <div className="w-10 h-10 rounded-full overflow-hidden flex items-center justify-center">
            <img
              src={LOGO_URL}
              alt="찬연기아카데미 로고"
              className="w-full h-full object-cover"
            />
          </div>
          <span
            className={`font-serif-kr font-bold text-lg tracking-tight whitespace-nowrap transition-colors duration-300 ${
              scrolled ? 'text-neutral-900' : 'text-white'
            }`}
          >
            찬연기아카데미
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link, i) => (
            <a
              key={i}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className={`text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                activeSection === link.href.replace('#', '')
                  ? scrolled
                    ? 'text-red-800'
                    : 'text-red-400'
                  : scrolled
                  ? 'text-neutral-600 hover:text-neutral-900'
                  : 'text-white/80 hover:text-white'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Mobile Menu Toggle */}
        <button
          className={`lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? 'text-neutral-900' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-stone-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link, i) => (
            <a
              key={i}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="text-sm font-medium text-neutral-700 hover:text-red-800 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
